import CyberActionButton from "../../components/ui/CyberActionButton";
import MorseBeacon from "../../components/intro/MorseBeacon";
import { variantColorClass, variantAvClass } from "../../components/ui/GameHudStyles";
import { getRoomInfo } from "../../games/rooms";
import { getAvatarUrl } from "../../avatars";
import { getRoleLabel } from "../game/gameRoles";

export default function GameDrawerTeam({
  onClose,
  openIntro, setHintSignal,
  state, players, me, morse,
  openRoomPreview,
}) {
  return (
    <div className="fixed inset-0 z-50 [@media(min-width:1420px)]:hidden">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute right-0 top-0 bottom-0 w-72 flex flex-col overflow-hidden"
        style={{ background: "#04050f", borderLeft: "1px solid rgba(255,255,255,.07)" }}>

        <div style={{ padding: "14px 16px 10px", borderBottom: "1px solid rgba(255,255,255,.06)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontSize: 9, letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(99,102,241,.7)", fontWeight: 700, fontFamily: "ui-monospace,monospace" }}>
            ◈ ÉQUIPE & INDICES
          </div>
          <button onClick={onClose}
            style={{ width: 28, height: 28, borderRadius: 6, border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)", color: "rgba(148,163,184,.8)", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "8px 10px", borderBottom: "1px solid rgba(255,255,255,.04)", display: "flex", gap: 6 }}>
          <CyberActionButton variant="brief" label="BRIEF" tag="Accès" arcOffset={42} onClick={() => { onClose(); openIntro(); }} />
          <CyberActionButton variant="hints" label="INDICES" tag="Module" arcOffset={28} onClick={() => { onClose(); setHintSignal(n => n + 1); }} />
        </div>

        <div style={{ padding: "8px 12px 4px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 9, letterSpacing: ".18em", color: "rgba(148,163,184,.75)", textTransform: "uppercase", fontWeight: 700, fontFamily: "ui-monospace,monospace" }}>Équipe en mission</span>
          <span style={{ fontSize: 9, color: "rgba(100,116,139,.6)", fontFamily: "ui-monospace,monospace" }}>Étape {state.stage} · {players.length}J</span>
        </div>

        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "4px 8px", display: "flex", flexDirection: "column", gap: 4 }} className="custom-scrollbar">
          {players.map(p => {
            const isMe = p.id === me.id;
            const avatarUrl = getAvatarUrl(p.avatar);
            const role = getRoleLabel(p);
            const room = getRoomInfo(state.gameId ?? 1, state.stage, p.pageVariant);
            const showMorseOnThumb = !isMe && p.pageVariant === 1 && !!morse?.morseActive && !!morse?.morseStartedAt && state.stage === 1;
            const initials = (p.pseudo || "?").slice(0, 2).toUpperCase();
            return (
              <div key={p.id}
                className={`hud-pcard ${isMe ? "hud-pc-me" : variantColorClass(p.pageVariant)}`}
                onClick={() => { onClose(); openRoomPreview(p); }}>
                <div className={`hud-av ${isMe ? "hud-av-1" : variantAvClass(p.pageVariant)}`}>
                  {avatarUrl ? <img src={avatarUrl} alt={p.pseudo} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} /> : initials}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "rgba(241,245,249,.95)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontFamily: "ui-sans-serif,system-ui", display: "flex", alignItems: "center", gap: 5, lineHeight: 1.3 }}>
                    {p.pseudo}{isMe && <span className="hud-ptag">toi</span>}
                  </div>
                  <div style={{ fontSize: 11, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 2 }}>{role}</div>
                  <div style={{ fontSize: 10, color: "rgba(100,116,139,.7)", fontFamily: "ui-monospace,monospace", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 1 }}>{room?.label || "—"}</div>
                </div>
                {room?.icon && (
                  <button type="button" onClick={(e) => { e.stopPropagation(); onClose(); openRoomPreview(p); }}
                    style={{ width: 36, height: 36, borderRadius: 7, overflow: "hidden", background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.12)", flexShrink: 0, position: "relative", cursor: "pointer" }}>
                    <img src={room.icon} alt={room.label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    {showMorseOnThumb && <MorseBeacon active syncStartedAt={morse?.morseStartedAt} syncResetCounter={morse?.morseResetCounter || 0} serverNow={morse?.serverNow} hideResetLabel className="inset-0 !w-full !h-full" />}
                    <div style={{ position: "absolute", top: -3, right: -3, background: "rgba(99,102,241,.9)", border: "1px solid rgba(255,255,255,.2)", borderRadius: "50%", fontSize: 7, padding: "1px 3px" }}>🔍</div>
                  </button>
                )}
              </div>
            );
          })}
          {players.length === 0 && <p style={{ fontSize: 11, color: "rgba(71,85,105,.6)", fontFamily: "ui-monospace,monospace", padding: "8px 4px" }}>Aucun joueur connecté.</p>}
        </div>
      </div>
    </div>
  );
}